module.exports = __webpack_public_path__ + "static/media/PRESTO-Header-Logo.3f4c762b.svg";